import { Repository } from "react3l-common";
import { kebabCase } from "lodash";
import { httpConfig } from "config/http";
import { BASE_API_URL } from "config/consts";
import { map, Observable } from "rxjs";
import { API_USER_MANUAL_PREFIX } from "config/api-consts";
import { UserManual, UserManualFilter } from "models/UserManual";
import nameof from "ts-nameof.macro";
import { Site, SiteFilter } from "models/Site";

export type KeyType = string | number;

export class UserManualRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.baseURL = new URL(API_USER_MANUAL_PREFIX, BASE_API_URL).href;
  }

  public list = (
    userManualFilter?: UserManualFilter
  ): Observable<UserManual[]> => {
    return this.http
      .post<UserManual[]>(kebabCase(nameof(this.list)), userManualFilter)
      .pipe(Repository.responseMapToList<UserManual>(UserManual));
  };

  public count = (userManualFilter?: UserManualFilter): Observable<number> => {
    return this.http
      .post<number>(kebabCase(nameof(this.count)), userManualFilter)
      .pipe(Repository.responseDataMapper<number>());
  };

  public get = (id: number | string): Observable<UserManual> => {
    return this.http
      .post<UserManual>(kebabCase(nameof(this.get)), { id })
      .pipe(Repository.responseMapToModel<UserManual>(UserManual));
  };

  public create = (userManual: UserManual): Observable<UserManual> => {
    return this.http
      .post<UserManual>(kebabCase(nameof(this.create)), userManual)
      .pipe(Repository.responseMapToModel<UserManual>(UserManual));
  };

  public update = (userManual: UserManual): Observable<UserManual> => {
    return this.http
      .post<UserManual>(kebabCase(nameof(this.update)), userManual)
      .pipe(Repository.responseMapToModel<UserManual>(UserManual));
  };

  public delete = (userManual: UserManual): Observable<UserManual> => {
    return this.http
      .post<UserManual>(kebabCase(nameof(this.delete)), userManual)
      .pipe(Repository.responseMapToModel<UserManual>(UserManual));
  };

  public bulkDelete = (idList: KeyType[]): Observable<void> => {
    return this.http
      .post(kebabCase(nameof(this.bulkDelete)), idList)
      .pipe(Repository.responseDataMapper());
  };

  public save = (userManual: UserManual): Observable<UserManual> => {
    return userManual.id ? this.update(userManual) : this.create(userManual);
  };

  public singleListSite = (siteFilter: SiteFilter): Observable<Site[]> => {
    return this.http
      .post<Site[]>(kebabCase(nameof(this.singleListSite)), siteFilter)
      .pipe(Repository.responseMapToList<Site>(Site));
  };

  public upload = (files?: any): Observable<any> => {
    const formData: FormData = new FormData();
    formData.append("file", files[0] as Blob);
    return this.http
      .post<File>(kebabCase(nameof(this.upload)), formData)
      .pipe(map((r) => [r.data]));
  };
}

export const userManualRepository = new UserManualRepository();
